<template>
  <div>
    <ReportPieChart
      ref="courtChart"
      :height="height"
      :width="width"
      :report-data="reportData"
      :legend="legend"
      :show-percentages="true"
      title="Corruption Cases by Court"
    />
  </div>
</template>

<script>
import axios from "axios";
import ReportPieChart from "./ReportPieChart.vue";

export default {
  components: {
    ReportPieChart
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fhc: 0,
      shc: 0,
      fct: 0,
      // ac: 0,
      // sc: 0,
      cct: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    reportData() {
      return {
        "Federal High Courts": this.fhc,
        "State High Courts": this.shc,
        "FCT High Courts": this.fct,
        // "Appeal Court": this.ac,
        // "Supreme Court": this.sc,
        "Code of Conduct Tribunal": this.cct
      };
    },
    legend() {
      return {
        "Federal High Courts": "#20336e",
        "State High Courts": "#5c61be",
        "FCT High Courts": "#3286aa",
        // "Appeal Court": "#8a0829",
        // "Supreme Court": "#7401df",
        "Code of Conduct Tribunal": "#1c96a3"
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      axios
        .get(`${window.host}/api/court-cases`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.fhc = response.data.fhc;
            this.shc = response.data.shc;
            this.fct = response.data.fct;
            // this.ac = response.data.ac;
            // this.sc = response.data.sc;
            this.cct = response.data.cct;
          }
        });
    }
  }
};
</script>
